import {AuthConfig, OAuthModuleConfig} from 'angular-oauth2-oidc';
import {environment} from "../environments/environment";
declare var cordova;
export const authConfig: AuthConfig = {
    issuer: environment.authenticationUrl,
    customQueryParams: {
        organizationUUID: environment.organizationUUID,
        userType: "ApplicationUser@cataleanUser",
        prompt: "login"
    },
    oidc: true,
/*     dummyClientSecret: 'eB5KcBsELe9jZRjA', */
    requireHttps: environment.production,
    clientId: 'tecomec-integration', // The "Auth Code + PKCE" client
    responseType: 'code',
    redirectUri: window['cordova'] && cordova.platformId === 'android'? 'it.addiction.catalean.tecomec://': window.location.origin + '/index.html',
    logoutUrl: window['cordova'] && cordova.platformId === 'android'? 'it.addiction.catalean.tecomec://': window.location.origin + '/index.html',
    scope: 'openid profile email offline_access',
    timeoutFactor: 0.75, // For faster testing
    sessionChecksEnabled: false,
    showDebugInformation: !environment.production,
    clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
    nonceStateSeparator: 'semicolon', // Real semicolon gets mangled by IdentityServer's URI encoding
/*     openUri: (uri) => {
      if(!!window['cordova'] && cordova.platformId === 'android') {
        const currentLocation = location.href;
        const ref = cordova.InAppBrowser.open(uri, '_blank','location=no,zoom=no')
        ref.addEventListener('loadstart', (event) => {
          if(event.url.includes('it.addiction.catalean.tecomec')) {
            location.href = currentLocation+event.url.replace('http://it.addiction.catalean.tecomec://','')
            ref.close()
          }
        })
      } else {
        location.href = uri
      }
    } */
};

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [environment.productsUrl, environment.structuresUrl],
    sendAccessToken: true,
  }
};
